module.exports = __webpack_public_path__ + "static/media/Glo.18a57718.svg";